export const COUNTRY_PLACEHOLDER = 'Search for your country';
export const STATE_PLACEHOLDER = 'Search for your state or province';
